export enum ProductSize {
    S = "S",
    M = "M",
    L = "L",
    XL = "XL",
    XXL = "XXL",
    XXXL = "XXXL",
    ONESIZE = "ONESIZE",
}

export enum ProductShoeSize {
    EU_36 = "36",
    EU_37 = "37",
    EU_38 = "38",
    EU_39 = "39",
    EU_40 = "40",
    EU_41 = "41",
    EU_42 = "42",
    EU_43 = "43",
    EU_44 = "44",
    EU_45 = "45",
    EU_46 = "46",
    EU_47 = "47",
}

export enum ProductStatus {
    PAUSE = "PAUSE",
    PROCESS = "PROCESS",
    DELETE = "DELETE",
}

export enum ProductCollection {
    CLOTHE = "CLOTHE",
    PANTS = "PANTS",
    HAT = "HAT",
    SHOES = "SHOES",
    OTHERS = "OTHERS",
}
